import { memo } from 'react'
import { Form, Input } from 'antd'
import { CustomizeFeeRateProps } from '@/hooks/fee/validator'
import { useValidateLegacyEVMFeeFields } from '@/hooks/fee/legacyEVM'

const EVMLegacyFeeRate: React.FC<CustomizeFeeRateProps> = props => {
  const { value, unit } = props
  const { errorMap, handleChangeFeeRate, handleChangeGasLimit } =
    useValidateLegacyEVMFeeFields(props)

  const feeRateError = errorMap?.feeRate?.message
  const gasLimitError = errorMap?.gasLimit?.message

  return (
    <Form layout="vertical">
      <Form.Item
        label={`GasPrice (${unit})`}
        validateStatus={feeRateError && 'error'}
        help={feeRateError}
      >
        <Input value={value.feeRate} onChange={evt => handleChangeFeeRate(evt.target.value)} />
      </Form.Item>
      <Form.Item label="GasLimit" validateStatus={gasLimitError && 'error'} help={gasLimitError}>
        <Input value={value.gasLimit} onChange={evt => handleChangeGasLimit(evt.target.value)} />
      </Form.Item>
    </Form>
  )
}

export default memo(EVMLegacyFeeRate)
